import axios from "axios";

import { Snackbar } from "@js/components/snackbar";
import { handleDownloadFile } from "@js/utils";

import type { CustomerInvoiceReportFiltersFormParamsType } from "./filters";

export const downloadCustomerInvoiceReportPDFs = (
  params: Partial<CustomerInvoiceReportFiltersFormParamsType>,
) =>
  axios
    .get("/api/invoice_report/download_zip/", { responseType: "blob", params })
    .then((response) => {
      const downloadUrl = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "invoice_report.zip");
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch(() =>
      Snackbar.error(
        "Please, narrow your search criteria to enable PDF download.",
      ),
    );

export const downloadCustomerInvoiceReportCSV = (
  params: Partial<CustomerInvoiceReportFiltersFormParamsType> & {
    format: string;
  },
) => {
  const { report } = params;
  const endpointByReport: Record<string, string> = {
    xero_invoice_report: "/api/xero_invoice_report/",
    employer_address_report: "/api/employer_address_report/",
  };
  const endpoint =
    (typeof report === "string" && endpointByReport[report]) ||
    "/api/invoice_report/";

  handleDownloadFile({ endpoint, params });
};

export const approveTalent = (talentId: number) =>
  axios.post(`/api/talent/${talentId}/approve/`);

export const rejectOfferInTalentBehalf = (id: number) =>
  new Promise((resolve, reject) =>
    axios
      .post(`/api/offer_report/${id}/reject_offer_in_behalf_of_freelancer/`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data)),
  );

export const markWithdrawalAsCompleted = (withdrawalTransactionId: number) =>
  new Promise((resolve, reject) => {
    return axios
      .post(
        `/api/token_transactions/${withdrawalTransactionId}/mark_as_completed/`,
      )
      .then(resolve)
      .catch((error) => {
        reject(error.response.data);
      });
  });
